import { renderApp } from '@/src/utilities/component-utilities';

import HomeMessage from './HomeMessage.vue';

export function loadHome(): void {
  if (!document.querySelector('urmc-home')) {
    return;
  }

  renderApp(HomeMessage, 'urmc-home');
}
